// Create or update a goal alert rule from the builder dialog
// (POST /goals/:goalId/alerts | PUT /goals/:goalId/alerts/:alertId).
const action = "DISCOVERY_SAVE_ALERT";
export const REQUEST = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE = action + '_FAILURE';
export const CLEAR = action + '_CLEAR';

// payload: { goalId, alertId?, data } — alertId present -> PUT update.
export const fetchRequest = (payload) => ({ type: REQUEST, payload });
export const fetchSuccess = (response) => ({ type: RESPONSE, payload: response });
export const fetchFailure = (error) => ({ type: FAILURE, payload: error });
export const clearState = () => ({ type: CLEAR });
